export default __webpack_public_path__ + "static/media/organicos.34e352a0.svg";